module.exports = __webpack_public_path__ + "img/電気回路_3_9_4.2691c531.png";